import { render, staticRenderFns } from "./IntroSlides.vue?vue&type=template&id=0de60aaa&scoped=true&"
import script from "./IntroSlides.vue?vue&type=script&lang=ts&"
export * from "./IntroSlides.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de60aaa",
  null
  
)

export default component.exports